import PropTypes from 'prop-types';
import React from 'react';
import { cx, css } from 'emotion';
import AbstractFilteredList from 'components/core/AbstractFilteredList';
import ListItem from 'components/core/ListItem';
import Flexbox from 'flexbox-react';
import { colorTextGrey } from 'styles/base';

export default class DatastreamVarsList extends AbstractFilteredList {

    static propTypes = {
        process: PropTypes.object,
        selectable: PropTypes.bool,
        datastreamName: PropTypes.string
    };

    constructor(props) {
        super(props);
        this.resetFilter();
    }

    componentWillUpdate(nextProps, nextState) {

        // if the selected dod has changed, then we need to clear the filter
        if (nextProps.datastreamName !== this.props.datastreamName) {
            this.resetFilter();
        }
    }

    resetFilter() {
        this.setLSState(
            { filter: '' },
            { update: false } // reset the local storage, but don't trigger a UI state change
        ); 
    }

    getItemClassName() {
        let selectableClass = '';
        if (this.props.selectable === false) {
            selectableClass = 'read-only';
        }
        return `variable-item ${selectableClass}`;
    }

    getListClassName() {
        return 'variable-list';
    }

    getListItemsClassName() {
        return 'variable-list-items';
    }

    //overriding parent's onDocumentClick so that when clicks are made outside of list selections aren't lost
    onDocumentClick = (e) => {};

    doNothing = () => {
    };

    renderFilterSection(filteredLength, length) {
        const filter = this.getFilter();
        const wrapperStyle = css`flex-shrink: 0;`;

        // Only show the filter box if we actually have data in the table
        if (this.props.filterable) {
            const displayQCmessage = filter == 'qc' && filteredLength == 0;
            return (
                <Flexbox flexDirection="column" className={cx('filter-wrapper', wrapperStyle)}>
                    <input
                        flex={1}
                        ref="filterInput"
                        className={this.getInputClassName()}
                        type="text" placeholder={this.getPlaceholder()}
                        onChange={this.onFilterChanged}
                        value={filter}
                    />
                    {this.renderCheckboxFilters()}
                    <p className="found">Showing {filteredLength} of {length}: </p>
                    {displayQCmessage && 
                        <p className={css`color:${colorTextGrey}; padding: 5px 10px 0px 10px;margin-bottom:0;`}><em>qc variables not displayed, retrieve variable with retrieve qc option selected to yes</em></p>
                        }
                </Flexbox>
            );
        } else {
            return null;
        }
    }

    renderItem(name, value, selected) {

        // If this is the special cVars (coordinate variables list), ignore it
        if (name === 'cVars') {
            return null;
        } else {
            let dims = '';
            if (value.dims !== null) {
                dims = value.dims.reduce((accumulator, currentValue) => {
                    if (accumulator === '') {
                        return currentValue;
                    } else {
                        return `${accumulator}, ${currentValue}`;
                    }
                }, '');
            }
            let units = '[no units]';
            if (value.units !== null) {
                units = value.units;
            }
            let onClick = this.onClick;
            if (this.props.selectable !== undefined && this.props.selectable === false) {
                onClick = this.doNothing;
            }
            return (
                <ListItem
                    key={name}
                    name={name}
                    selected={selected}
                    className={this.getItemClassName()}
                    onClick={onClick}
                    onDoubleClick={this.props.onDoubleClick}
                >
                    <Flexbox marginLeft="15px" flexDirection="row">
                        <span className="dash">&mdash;</span>
                        <strong>{name}</strong>
                        <div className="sub-text">({dims}) : {units}</div>
                    </Flexbox>
                </ListItem>
            );

        }
    }

}



// WEBPACK FOOTER //
// ./src/components/page/process/variableRetrieval/DatastreamVarsList.js